import { getPPAuthToken, ResponseModel } from '@r-and-a-shared-ui/utils';
import { ActionHandlerParams } from '../../types';
import {
  PP_CreateOnlineEntryInputSchema,
  pp_onlineEntryCreationDefaultValues,
} from '@r-and-a-shared-ui/randa-trpc-server/input-schemas';
import { pp_genericMutationHandlerWithFormValidation } from '../pp-form-action-mutation-handlers';

export const handle = async (
  params: ActionHandlerParams,
): Promise<ResponseModel> => {
  const authTokenMutation = params.authTokenMutation;

  if (authTokenMutation) {
    params.bearerToken = await getPPAuthToken(authTokenMutation?.mutateAsync);
  }

  setSpecificAdditionalFields(params.submitData);

  const resultData = await pp_genericMutationHandlerWithFormValidation(
    params,
    PP_CreateOnlineEntryInputSchema,
    pp_onlineEntryCreationDefaultValues,
  );
  if (resultData?.hasErrors) {
    return resultData;
  }

  return resultData;
};

const setSpecificAdditionalFields = (submitData: any) => {
  submitData.referrer = window?.location?.origin || '';
  submitData.onlineEntry_handicapCategory = submitData?.handicapCategory || '';

  if (
    Array.isArray(submitData.onlineEntry_pgaTour) &&
    !!submitData.onlineEntry_pgaTourOther
  ) {
    submitData.onlineEntry_pgaTour.push(submitData.onlineEntry_pgaTourOther);
  }

  if (submitData.onlineEntry_privacyPolicyAcceptedUnder18) {
    submitData.onlineEntry_privacyPolicyAccepted =
      submitData.onlineEntry_privacyPolicyAcceptedUnder18;
  }
};
export default handle;
